import { Link } from "react-router-dom";
import { NAV } from "../data/site";
import { WA_DISPLAY, waLink } from "../lib/whatsapp";
import { MessageSquareText } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0B1F3A] text-white/80 mt-24">
      <div className="absolute inset-x-0 top-0 gold-rule opacity-70" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 rounded-full border border-[#C8A96A] flex items-center justify-center">
              <span className="w-2 h-2 rounded-full bg-[#C8A96A]" />
            </span>
            <span className="font-serif text-[26px] text-white">
              Easy<span className="text-[#C8A96A]">ilaaz</span>
            </span>
          </div>
          <p className="mt-6 font-serif text-2xl leading-snug text-white/90 max-w-md">
            Healthcare. Simplified.<br/>Personally managed.
          </p>
          <p className="mt-6 text-[13px] leading-relaxed text-white/60 max-w-md">
            India's private medical concierge for NRIs and international patients. One
            dedicated concierge. One point of contact. From consultation to recovery.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="overline text-[#C8A96A]">Navigate</div>
          <ul className="mt-6 space-y-3 text-[14px]">
            {NAV.map((n) => (
              <li key={n.to}><Link className="link-elegant text-white/80 hover:text-white" to={n.to}>{n.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="overline text-[#C8A96A]">Concierge Desk</div>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li className="text-white/80">concierge@easyilaaz.com</li>
            <li>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 text-white/80 hover:text-[#C8A96A] link-elegant transition-colors"
              >
                <MessageSquareText size={14} strokeWidth={1.25} className="text-[#C8A96A]" />
                WhatsApp {WA_DISPLAY} · 24 × 7
              </a>
            </li>
            <li className="text-white/60 mt-6 text-[12px] leading-relaxed">
              Easyilaaz is a private healthcare concierge and navigation platform. We do
              not diagnose or treat medical conditions. All clinical advice is provided
              exclusively by licensed doctors and accredited hospitals in our network.
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[12px] text-white/50">
          <div>© {new Date().getFullYear()} Easyilaaz Private Concierge. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="link-elegant hover:text-white/80">Privacy</Link>
            <Link to="/terms" className="link-elegant hover:text-white/80">Terms</Link>
            <Link to="/disclaimer" className="link-elegant hover:text-white/80">Medical Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
